import { takeLatest } from 'redux-saga/effects'
import { tryDeletePredictionCampaign } from 'redux/slices/predictionSlice'
import { tryCreatePredictionCategory } from 'redux/slices/predictionSlice'
import { tryDeletePredictionCategory } from 'redux/slices/predictionSlice'
import { tryDeleteCandidate ,tryUpdateCandidate } from 'redux/slices/predictionSlice'
import { tryGetPredictionResult } from 'redux/slices/predictionSlice'
import { tryGetPredictionSearchResult } from 'redux/slices/predictionSlice'
import { tryGetCandidates } from 'redux/slices/predictionSlice'
import { tryCreateCandidate } from 'redux/slices/predictionSlice'
import { tryUpdatePredictionCategory } from 'redux/slices/predictionSlice'
import { tryGetPredictionCategoryInfo } from 'redux/slices/predictionSlice'
import { tryUpdatePredictionCampaign } from 'redux/slices/predictionSlice'
import { tryCreatePredictionCampaign, tryGetPredictionCampaign} from 'redux/slices/predictionSlice'
import { handleCreateCandidates, handleCreatePredictionCampaign, handleCreatePredictionCategory, handleDeletePredictionCampaign, handleGetCadidates, handleGetPredictionCampaign, handleGetPredictionCategoryInfo, handleRemoveCandidate, handleRemovePredictionCategory, handleUpdateCandidate, handleUpdatePredictionCampaign, handleUpdatePredictionCategory , handleGetPredictionResults, handleGetSearchResults} from '../handlers/predictionHandler'


const predictionSaga = [
  takeLatest(tryGetPredictionCampaign.type, handleGetPredictionCampaign),
  takeLatest(tryCreatePredictionCampaign.type, handleCreatePredictionCampaign),
  takeLatest(tryUpdatePredictionCampaign.type, handleUpdatePredictionCampaign),
  takeLatest(tryDeletePredictionCampaign.type, handleDeletePredictionCampaign),
  takeLatest(tryGetPredictionCategoryInfo.type, handleGetPredictionCategoryInfo),
  takeLatest(tryCreatePredictionCategory.type, handleCreatePredictionCategory),
  takeLatest(tryUpdatePredictionCategory.type, handleUpdatePredictionCategory),
  takeLatest(tryDeletePredictionCategory.type, handleRemovePredictionCategory),
  takeLatest(tryGetCandidates.type, handleGetCadidates),
  takeLatest(tryCreateCandidate.type, handleCreateCandidates),
  takeLatest(tryUpdateCandidate.type, handleUpdateCandidate),
  takeLatest(tryDeleteCandidate.type, handleRemoveCandidate),
  takeLatest(tryGetPredictionResult.type,handleGetPredictionResults),
  takeLatest(tryGetPredictionSearchResult.type, handleGetSearchResults)
]

export default predictionSaga

